import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHomeClusters() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      clusterID: isEmpty(state.clusterID),
    };

    setter(errorState);

    if (errorState.title || errorState.productCount || errorState.clusterID) {
      enqueueSnackbar("اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const ProductCluster = (clusterID, callback) => {
    MyAxios.get(`Admin_HomeCluster`, {
      headers: {
        AID: clusterID,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const ProductClusterFrame = (clusterID, callback) => {
    MyAxios.get(`Admin_HomeCluster/${clusterID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateProductCluster = (state, Icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Icon) {
      data.append("Icon", Icon);
    }
    MyAxios.put(`Admin_HomeCluster`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت ویرایش شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddProductCluster = (state, Icon, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (Icon) {
      data.append("Icon", Icon);
    }
    MyAxios.post(`Admin_HomeCluster`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("اطلاعات با موفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    ProductCluster,
    UpdateProductCluster,
    AddProductCluster,
    validate,
    ProductClusterFrame,
  };
}
